const ReduxSliceNames = {
  LoadingFullScreen: 'LoadingFullScreen'
};

export default ReduxSliceNames;
